import React, { createContext, ReactNode, useContext, useEffect, useSyncExternalStore } from "react";
import { socketClient } from "@/services/socketClient";
import { SocketConnectionState } from "@/model/interface/SocketConnection";

const SocketContext = createContext<SocketConnectionState | undefined>(undefined);

export function SocketProvider({ children }: { children: ReactNode }) {
  const state = useSyncExternalStore(socketClient.onStateChange, socketClient.getState);

  useEffect(() => {
    socketClient.start();
    return () => {
      socketClient.stop();
    };
  }, []);

  return <SocketContext.Provider value={state}>{children}</SocketContext.Provider>;
}

export function useSocketConnection(): SocketConnectionState {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error("useSocketConnection must be used within a SocketProvider");
  }
  return context;
}
